export const en = {
    'select-ad-platforms': 'Advertising surface selection',
    'select-ad-platforms-diff-group':
        'Select advertising surfaces. Check their formats, and only select the ones where your size of creatives will fit. You can choose advertising surfaces in several cities at the same time.'
};
